import { Button } from "@/components/ui/button"
import { Spinner } from "@craft-agent/ui"
import { OriginRelaySymbol } from "@/components/icons/OriginRelaySymbol"
import { StepFormLayout } from "./primitives"

interface CompletionStepProps {
  status: 'saving' | 'complete'
  spaceName?: string
  onFinish: () => void
}

/**
 * CompletionStep - Success screen after onboarding
 *
 * Shows:
 * - saving: Spinner while saving configuration
 * - complete: Success message with option to start
 */
export function CompletionStep({
  status,
  spaceName,
  onFinish
}: CompletionStepProps) {
  const isSaving = status === 'saving'

  return (
    <StepFormLayout
      iconElement={isSaving ? (
        <div className="flex size-16 items-center justify-center">
          <Spinner className="text-2xl text-foreground" />
        </div>
      ) : (
        <div className="flex size-16 items-center justify-center">
          <OriginRelaySymbol className="size-10 text-foreground" />
        </div>
      )}
      title={isSaving ? 'Setting up...' : "You're all set!"}
      description={
        isSaving ? (
          'Saving your configuration...'
        ) : (
          'Just start a chat and get to work.'
        )
      }
      actions={
        status === 'complete' ? (
          <Button onClick={onFinish} className="w-full max-w-[320px] bg-background shadow-minimal text-foreground hover:bg-foreground/5 rounded-lg" size="lg">
            Get Started
          </Button>
        ) : undefined
      }
    />
  )
}
